import Link from "next/link";
import { Tabs } from "ui";
import { useCarriedQueryParams } from "./utils";

export function SubscriptionNavigationTabs({
  activeTab,
}: {
  activeTab: "plans" | "subscriptions" | "planGroups";
}) {
  const query = useCarriedQueryParams();
  return (
    <Tabs value={activeTab}>
      <Tabs.List>
        <Tabs.Tab
          value="plans"
          nativeButton={false}
          render={<Link href={{ pathname: "/plans", query }} />}
        >
          Manage Plans
        </Tabs.Tab>
        <Tabs.Tab
          value="subscriptions"
          nativeButton={false}
          render={<Link href={{ pathname: "/subscriptions", query }} />}
        >
          Manage Subscriptions
        </Tabs.Tab>
        <Tabs.Tab
          value="planGroups"
          nativeButton={false}
          render={<Link href={{ pathname: "/subscription-embeds", query }} />}
        >
          Manage Plan Groups
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
